export const cleanRawString = (rawString: string) =>
  decodeURIComponent(rawString ?? '')
    .replace(/\+/g, ' ')
    .replace(/\|/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/\s{2,}/g, ' ')
    .trim();
